import React from 'react'

import DatePicker from '../../../DatePicker'
import { FORMAT_DATE } from '../../../../helpers'

const RepeatEndDatePicker = (props) => {
  const {
    className, 
    isSelected,
    isOpenDatePicker,
    selectedDate,
    onPressDatePicker, 
    onCloseDatePicker,
    handleSelectedDate,
    language,
    getHolidays,
    holidays,
    colorTheme
  } = props

  const boxTextStyle = isSelected ? 'box-active-option padding-option' : 'box-option padding-option' 
  const textStyle = isSelected ? 'box-option-active-text' : 'box-option-text'

  return (
    <div className={className}>
      <div
        className={boxTextStyle}
        onClick={() => onPressDatePicker(isSelected)}
      >
        <label className={textStyle}>
          {selectedDate.locale(language.toLowerCase()).format(FORMAT_DATE.REPEAT_BOOKING_ENDS_ON)}
        </label>
      </div>

      {
        isOpenDatePicker && (
          <DatePicker
            colorTheme={colorTheme}
            selectDate={new Date(selectedDate)}
            handleCloseButton={onCloseDatePicker}
            handleSaveButton={(_, selectedDate) => handleSelectedDate(selectedDate)}
            startSelectable={new Date()}
            language={language}
            getHolidays={getHolidays}
            listHoliday={holidays}
          />
        )
      }
    </div>
  )
}

export default RepeatEndDatePicker
